import type { JSX } from "solid-js";
import { render } from "solid-js/web";

/**
 * Returns the style used for the scoped shadow DOM
 */
export function getScopedStyle() {
	return sessionStorage.getItem("yaa-web-widgets:style") || (window as any).YaaWebWidgetsStyle || "";
}

export function createStyleElement(shadow: ShadowRoot, additionalStyle?: string) {
	const style = document.createElement("style");
	const css = document.createTextNode(getScopedStyle());

	// Add additional style
	if (additionalStyle) {
		css.nodeValue += additionalStyle;
	}

	style.appendChild(css);
	shadow.appendChild(style);

	return style;
}

/**
 * Render a SolidJS component in a scoped shadow DOM
 *
 * @param code The component to render
 * @param element The element to render the component in
 */
export function renderScoped(code: () => JSX.Element, element: HTMLElement) {
	const shadow = element.attachShadow({ mode: "open" });
	createStyleElement(shadow);

	render(code, shadow);
}
